<template>
  <label class="file-select uk-align-left">
    <!-- We can't use a normal button element here, as it would become the target of the label. -->
    <div class="uk-margin-bottom">
      <a v-if="iconOnly" uk-icon="icon: upload" uk-tooltip="uploadText"></a>
      <!-- <p v&#45;else uk&#45;icon="icon: upload" class="uk&#45;button uk&#45;button&#45;primary" -->
      <template v-else>
        <p v-if="isLargeText" uk-icon="icon: upload; ratio: 1.4" class="uk-button uk-text-large"
                                       v-bind:class="classes()"
        >{{uploadText}}</p>
        <p v-if="isMediumText" uk-icon="icon: upload; ratio: 1.4" class="uk-button uk-text-medium"
                                       v-bind:class="classes()"
        >{{uploadText}}</p>
        <p v-else uk-icon="icon: upload" class="uk-button"
                                       v-bind:class="classes()"
        >{{uploadText}}</p>
      </template>
    </div>
    <!-- Now, the file input that we hide. -->
    <input type="file" accept=".pdf" @change="event => this.$emit('file-uploaded', event)" />
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UIkit from 'uikit';

export default defineComponent({
  name: 'UploadButton',
  components: {
  },
  props: {
    iconOnly: {
      type: Boolean,
      default: false,
    },
    uploadText: {
      type: String,
    },
    isPrimary: {
      default: true,
    },
    isSecondary: {
      default: false,
    },
    isRed: {
      default: false,
    },
    isGray: {
      default: false,
    },
    isMediumText: {
      default: false,
    },
    isLargeText: {
      default: false,
    },
  },
  computed: {
  },
  data() {
    return {
    };
  },
  methods: {
    classes() {
      return {
        'uk-button-red': this.isRed, 'uk-button-gray': this.isGray, 'uk-button-primary': this.isPrimary, 'uk-button-secondary': this.isSecondary,
      };
    },
  },
});
</script>

<style scoped>
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2ea169;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
}

/* Don't forget to hide the original file input! */
.file-select > input[type='file'] {
  display: none;
}

.uk-button-gray {
  background-color: #5a5a5a;
}
</style>
